module.exports = __webpack_public_path__ + "img/logo-white.1f447d36.svg";